import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";

export default function createOptInOutTrackingService(track: TrackFn) {
    return {
        trackKeepNewDesign: () => {
            track("Button", "Click", "Keep new design");
        },
        trackSwitchToOldDesign: () => {
            track("Button", "Click", "Opt out");
        },
        trackSwitchToNewDesign: () => {
            track("Button", "Click", "Opt in");
        },
        trackHoverBanner: () => {
            track("Banner", "Hover widget", "");
        },
        trackModalCancelClick: () => {
            track("Pop up", "Click", "Cancel");
        },
        trackModalSubmitClick: (value: string) => {
            track("Pop up", "Click", `Continue/${value}`);
        },
    };
}
